export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20collage%20on%20warm%20cream%20canvas%20background%2C%20scattered%20designer%20shoes%20and%20luxury%20accessories%20styled%20in%20editorial%20flat%20lay%2C%20soft%20diffused%20natural%20lighting%2C%20Mediterranean%20terracotta%20and%20sand%20color%20palette%2C%20artistic%20arrangement%20with%20textured%20linen%20cloth%20and%20dried%20eucalyptus%20branches%2C%20modern%20Italian%20aesthetic%2C%20warm%20beige%20tones%20with%20gentle%20shadows%2C%20creative%20fashion%20photography%20composition&width=1600&height=1000&seq=hero-bg-itaobuy-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti moda italiani"
          title="Itaobuy Spreadsheet Italia - Prodotti Moda"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 pt-24">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-semibold tracking-wide uppercase mb-6">
              Italia 2026
            </span>
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
              Itaobuy<br />
              Spreadsheet<br />
              <span className="text-primary-300">Italia</span>
            </h1>
            <p className="text-base md:text-lg text-background-200 max-w-lg mx-auto lg:mx-0 leading-relaxed mb-8">
              La guida definitiva per trovare i migliori prodotti di moda. Scarpe, sneakers, abbigliamento e accessori selezionati con cura. Risparmia tempo e denaro con lo spreadsheet piu completo.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full bg-primary-500 text-base font-semibold text-background-50 hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto justify-center"
              >
                Itaobuy Sheet
                <i className="ri-arrow-right-up-line text-lg"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full bg-background-50/90 text-base font-semibold text-foreground-950 hover:bg-background-50 transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto justify-center"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-500/20 to-accent-500/20 rounded-[40px] blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20items%20styled%20on%20warm%20cream%20marble%20surface%2C%20premium%20leather%20handbag%20and%20designer%20sunglasses%20with%20gold%20jewelry%20accents%2C%20soft%20natural%20window%20lighting%20from%20left%2C%20Mediterranean%20luxury%20aesthetic%2C%20warm%20terracotta%20and%20sand%20tones%2C%20editorial%20product%20photography%20with%20shallow%20depth%20of%20field%2C%20refined%20Italian%20style%20composition%2C%20gentle%20shadows%2C%20high%20end%20catalog%20shot&width=700&height=800&seq=hero-product-itaobuy-v2&orientation=portrait"
                alt="Itaobuy Spreadsheet prodotti moda"
                title="Itaobuy Spreadsheet Italia - Moda e Accessori"
                className="w-full rounded-[36px] relative z-10"
              />
            </div>
          </div>
        </div>

        <div className="absolute bottom-10 left-1/2 -translate-x-1/2">
          <div className="flex items-center gap-2 text-background-300/80 text-xs tracking-widest uppercase">
            <span>Scopri di piu</span>
            <i className="ri-arrow-down-line animate-bounce"></i>
          </div>
        </div>
      </div>
    </section>
  );
}